import React from 'react';
import ProductDebtSoldScreen, {
  DebtSoldProduct,
} from 'shared/components/DebtSale/ProductDebtSoldScreen/ProductDebtSoldScreen';

export default function Page() {
  return (
    <ProductDebtSoldScreen
      product={DebtSoldProduct.LineOfCredit}
      settings={{
        pathname: '/varo-line-of-credit/manage-account',
        analyticsId: 'debt_sold_settingsClicked',
      }}
    />
  );
}
